<div class="layout-menu-profile">
    <button class="p-link border-noround" (click)="toggleMenu()" pTooltip="Profile" [tooltipDisabled]="isTooltipDisabled">
        <img src="../../assets/layout/images/user_profile.png" alt="avatar" style="width: 32px; height: 32px;">
    
        <p style="color: #636e75;height: 19px;font-weight: 400;font-size: 12px;padding: 0.5rem;">{{updatedby}}</p>
        <i class="layout-menu-profile-toggler pi pi-fw" [ngClass]="{'pi-angle-down': menuProfilePosition === 'start' || isHorizontal, 'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal}"></i>
    </button>
</div>
